/** Must match server VIRTUAL_ROOM_COUNT (default 2). */
export const VIRTUAL_ROOM_COUNT = 2;

export function roomLabel(roomNumber) {
  return `HUONE ${roomNumber}`;
}

export function normalizeRoomNumber(value) {
  const n = Number(value);
  if (!Number.isInteger(n) || n < 1 || n > VIRTUAL_ROOM_COUNT) return 1;
  return n;
}
